import React from "react";
import { Chip, Stack, Typography } from "@mui/material";

import { DialogButton } from "../../components";

export const CustomerPartsBar = ({ customerId, disabled = false, count = 0 }) => {
  return (
    <Stack justifyContent="space-between" alignItems="end" direction="row">
      <Stack direction="row" gap="10px" alignItems="center">
        <Typography variant="boldCaption">Parts</Typography>
        <Chip label={`${count} Parts`} variant="colorTag" />
      </Stack>
      <Stack direction="row" gap="15px">
        <DialogButton
          name="create-customer-part"
          label="Create Part"
          value={customerId}
          variant="contained"
          size="xsmall"
          disabled={disabled}
        />
      </Stack>
    </Stack>
  );
};

export default CustomerPartsBar;
